import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { ARIAL_FONT, LIBERATION_SANS_FONT, LIBERATION_SERIF_FONT, LIBERATION_MONO_FONT } from 'pxc-editor-material-svg-rendering/constants';
import { setFontSizeCoef } from '@/actions/main';
import Modal from '@/components/Modals/Modal';
import { ModalBodyStyled, InputStyled } from './styles';

const FontSizeCoefModal = props => {
  const { setOpen } = props;
  const dispatch = useDispatch();
  const fontSizeCoef = useSelector(state => state.core.fontSizeCoef);
  const [value, setValue] = React.useState(fontSizeCoef[ARIAL_FONT]);
  const inputRef = React.useRef(null);

  const handleChange = e => {
    setValue(e.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApply = () => {
    if (value) {
      dispatch(setFontSizeCoef({
        [ARIAL_FONT]: value,
        [LIBERATION_SANS_FONT]: value,
        [LIBERATION_SERIF_FONT]: value,
        [LIBERATION_MONO_FONT]: value,
      }));
      handleClose();
    }
  };

  return (
    <Modal
      open
      setOpen={setOpen}
      handleClose={handleClose}
      handleApply={handleApply}
      height="150px"
      title={<FormattedMessage id="debug.fontSizeFactor" defaultMessage="Font-Size factor" />}
    >
      <ModalBodyStyled>
        <InputStyled
          type="number"
          inputMode="decimal"
          pattern="d\*"
          ref={inputRef}
          value={value}
          onChange={handleChange}
          onFocus={() => {
            if (inputRef.current) {
              inputRef.current.select();
            }
          }}
        />
      </ModalBodyStyled>
    </Modal>
  );
};

export default FontSizeCoefModal;
